
import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navigation = () => {
    const [scrolled, setScrolled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setIsOpen(!isOpen);

    const navStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        padding: '15px 0',
        backgroundColor: scrolled || isOpen ? 'rgba(255, 255, 255, 0.95)' : 'transparent',
        backdropFilter: scrolled || isOpen ? 'blur(20px)' : 'none',
        zIndex: 1000,
        transition: 'all 0.3s ease',
        borderBottom: (scrolled || isOpen) ? '1px solid var(--color-border)' : 'none',
    };

    const navContainerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        maxWidth: '1200px',
        margin: '0 auto'
    };

    const desktopMenuStyle = {
        display: 'flex',
        alignItems: 'center',
    };

    const linkStyle = {
        color: 'var(--color-text-primary)',
        margin: '0 15px',
        fontSize: '0.9rem',
        opacity: 0.8,
        textDecoration: 'none',
        fontWeight: '500',
        transition: 'opacity 0.3s'
    };

    const mobileMenuStyle = {
        position: 'fixed',
        top: '60px',
        left: 0,
        width: '100%',
        height: isOpen ? 'calc(100vh - 60px)' : '0',
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        transition: 'height 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        zIndex: 999,
        gap: '1.5rem'
    };

    const menuIconStyle = {
        display: 'none',
        fontSize: '1.5rem',
        cursor: 'pointer',
        color: 'var(--color-text-primary)',
        zIndex: 1001
    };

    const navLinks = [
        { href: "#about", label: "About" },
        { href: "#expertise", label: "Expertise" },
        { href: "#experience", label: "Experience" },
        { href: "#publications", label: "Publications" },
        { href: "#education", label: "Education" },
        { href: "#projects", label: "Research" },
        { href: "#academic-service", label: "Academic Service" },
        { href: "#honors", label: "Honors" },
        { href: "#contact", label: "Contact" }
    ];

    return (
        <>
            <style>
                {`
                    @media (max-width: 992px) {
                        .desktop-menu { display: none !important; }
                        .menu-icon { display: block !important; }
                    }
                `}
            </style>
            <nav style={navStyle}>
                <div style={navContainerStyle}>
                    <a href="#home" style={{ fontWeight: 'bold', fontSize: '1.2rem', color: 'var(--color-text-primary)', textDecoration: 'none' }}>MM</a>

                    <div className="desktop-menu" style={desktopMenuStyle}>
                        {navLinks.map(link => (
                            <a key={link.href} href={link.href} style={linkStyle} className="nav-link">{link.label}</a>
                        ))}
                    </div>

                    <div className="menu-icon" style={menuIconStyle} onClick={toggleMenu} aria-label="Toggle navigation menu">
                        {isOpen ? <FaTimes /> : <FaBars />}
                    </div>
                </div>

                <div style={mobileMenuStyle}>
                    {navLinks.map(link => (
                        <a
                            key={link.href}
                            href={link.href}
                            style={{ ...linkStyle, fontSize: '1.2rem', margin: '0' }}
                            onClick={() => setIsOpen(false)}
                        >
                            {link.label}
                        </a>
                    ))}
                </div>
            </nav>
        </>
    );
};

export default Navigation;
